import { convertPersianToGregorian } from '@/common/utils/convertPersianToGregorian.ts';
import convertTimestampToShamsi from '@/common/utils/convertTimestampToShamsi';
import { GetOwnerInformationQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/getOwnerInformation/getOwnerInformationQuery.type';
import { getInitialVisitOwnerInformationQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialVisitOwnerInformation/getInitialVisitOwnerInformationQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getInitialVisitOwnerInformationQueryOptions = (
  params: GetOwnerInformationQueryParamsType,
) =>
  queryOptions({
    queryKey: ['InitialVisitOwnerInformation', params],
    queryFn: () => getInitialVisitOwnerInformationQueryFunction(params),

    select: (data) => {
      if (!data) return undefined;

      const isRealOwner =
        data.personal_information?.owner_type?.const === 'real';

      const personalInformation: { label: string; value: string }[] = [];

      personalInformation.push({
        label: 'نوع مالکیت:',
        value: isRealOwner ? 'حقیقی' : 'حقوقی',
      });

      if (isRealOwner) {
        personalInformation.push(
          {
            label: 'جنسیت مالک :',
            value: data.personal_information?.gender?.fa_const ?? '-',
          },
          {
            label: 'نام :',
            value: data.personal_information?.first_name ?? '-',
          },
          {
            label: 'نام خانوادگی :',
            value: data.personal_information?.last_name ?? '-',
          },
          {
            label: 'تاریخ تولد :',
            value: convertPersianToGregorian(
              String(data.personal_information?.birthdate ?? ''),
            ),
          },
          {
            label: 'کد ملی :',
            value: data.personal_information?.national_code ?? '-',
          },
          {
            label: 'نام پدر :',
            value: data.personal_information?.father_name ?? '-',
          },
          {
            label: 'شماره شناسنامه :',
            value: data.personal_information?.identity_number ?? '-',
          },
          {
            label: 'محل صدور شناسنامه :',
            value: data.personal_information?.identity_issue_location ?? '-',
          },
        );
      } else {
        personalInformation.push(
          {
            label: 'نام :',
            value: data.personal_information?.name ?? '-',
          },
          {
            label: 'شماره ثبت  :',
            value: data.personal_information?.registration_number ?? '-',
          },
          {
            label: 'کد اقتصادی :',
            value: data.personal_information?.economic_code ?? '-',
          },
          {
            label: 'شناسه ملی :',
            value: data.personal_information?.national_id ?? '-',
          },
        );
      }

      return {
        originData: {
          ...data,
          personal_information: {
            ...data.personal_information,
            birthdate: convertTimestampToShamsi(
              data.personal_information?.birthdate,
            ),
          },
        },
        transformedData: {
          personal_information: personalInformation,
          contact_information: [
            {
              label: ' تلفن همراه :',
              value: data.contact_information?.phone_number ?? '-',
            },
            {
              label: ' تلفن ثابت :',
              value: data.contact_information?.phone ?? '-',
            },
            {
              label: 'کد پستی :',
              value: data.contact_information?.postal_code ?? '-',
            },
            {
              label: 'آدرس :',
              value: data.contact_information?.address ?? '-',
            },
          ],
        },
      };
    },
  });
